const PageLoadingFallback = () => {
  return <div>PageLoadingFallback</div>;
};

export default PageLoadingFallback;
